<template>
    <fragment>
        <div v-if="showModal">
            <transition name="modal">
                <div class="modal-mask" @click="closeMe($event)">
                    <div class="modal-wrapper">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" v-if="name" v-html="language.prompt.replacePlaceholders({ name : name })"></h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" @click="showModal = false">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p v-if="text" v-html="text"></p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="showModal = false">{{ language.close }}</button>
                            <form v-if="!ajaxreq" method="post" :action="route">
                                <input type="hidden" name="_token" :value="csrftoken">
                                <button class="btn btn-danger">{{ buttonText.length ? buttonText : language.delete }}</button>
                            </form>
                            <button v-on:click.prevent="deleteMe" v-else class="btn btn-danger" :disabled="isDeleting"><div v-if="isDeleting" class="spinner-border text-light" role="status"></div> {{ buttonText.length ? buttonText : language.delete }}</button>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </transition>
        </div>
        <button class="btn btn-danger delete-button" :class="{ 'delete-multi' : multi }" @click.prevent="showModal = true">{{ language.delete }}</button>
    </fragment>
</template>

<script>

import { Fragment } from 'vue-fragment'

import axios from "axios";

export default {

    components: {
        Fragment
    },

    data() {
        return {
            language : [],
            showModal : false,
            isDeleting : false
        }
    },

    mounted() {
        this.language = JSON.parse(this.translations)
    },

    computed: {

        csrftoken : function() {
            return document.querySelector('meta[name="csrf-token"]').content;
        }

    },

    props: {

        translations : String,

        route : String,

        name : String,

        text : {
            type: String,
            default: () => ''
        },

        buttonText : {
            type: String,
            default: () => ''
        },

        ajaxreq : {
            type: [Boolean, Number],
            default: () => false
        },

        multi : {
            type: [Boolean, Number],
            default: () => false
        },
    },

    methods : {

        closeMe: function(e) {

            if(e.target.classList.contains('modal-wrapper')) {
                this.showModal = false
            }

        },

        deleteMe: function() {

            this.isDeleting = true

            let data = {}

            if(this.multi) {

                let values = []

                const checkedCheckboxes = $('input.checkbox:checked')

                checkedCheckboxes.each(function(){
                    values.push($(this).val());
                });

                data = {
                    answers : values
                }

            }

            axios.post(this.route, data)

            .then(response => {

                if(this.multi) {

                    window.location.href = window.location.origin + window.location.pathname
                }

                if(response) {
                    this.$emit('deleted', true)
                    this.showModal = false
                    this.isDeleting = false
                }

            })

            .catch(err => {
                this.$emit('deleted', false)
                this.showModal = false
                this.isDeleting = false
            })


        }
    }
};
</script>


